import React, { useState, useRef, useEffect  } from 'react';
import { Link } from 'react-router-dom';
import './LatestSidebar.css';

// Ad data defined outside component so the reference is stable across renders
const ADS = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1486325212027-8081e485255e?w=350&h=200&fit=crop",
    title: "Future of Global Markets",
    sub: "Exclusive insights starting April 2026",
    link: "/markets"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=350&h=200&fit=crop",
    title: "Invest Smarter",
    sub: "Track global trends easily",
    link: "/terminal-demo"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=350&h=200&fit=crop",
    title: "AI Trading Tools",
    sub: "Upgrade your strategy",
    link: "/article/fed-hq-renovation-cost"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=350&h=200&fit=crop",
    title: "Crypto Insights",
    sub: "Stay ahead in digital assets",
    link: "/markets"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=350&h=200&fit=crop",
    title: "Wealth Management",
    sub: "Plan your future today",
    link: "/wealth"
  }
];

const LatestSidebar = () => {

  
  const [activeTab, setActiveTab] = useState('All Categories');

  const [activeRegion, setActiveRegion] = useState("India");

  const [activeSlide, setActiveSlide] = useState(0);

  const [adVisible, setAdVisible] = useState(true);


  const [activeAdIndex, setActiveAdIndex] = useState(0);

  // Rotate ads every 5 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveAdIndex(prev => (prev + 1) % ADS.length);
    }, 300000); // 5 minutes

    return () => clearInterval(interval);
  }, []);

  const currentAd = ADS[activeAdIndex];


 
  const newsletters = [
  {
    title: "Newsletter: The London Rush",
    subtitle: "Progress on Prices",
    image: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=400&h=250&fit=crop",
    link: "#"
  },
  {
    title: "Newsletter: Markets Daily",
    subtitle: "Global Stocks Rally",
     image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop",
    link: "#"
  },
  {
    title: "Newsletter: Asia Briefing",
    subtitle: "China Policy Moves",
     image:"https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=120&h=120&fit=crop",
    link: "#"
  },
  {
    title: "Newsletter: Tech In Depth",
    subtitle: "AI Regulation Debate",
      image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=400&h=250&fit=crop",
    link: "#"
  },
   {
    title: "Newsletter: Europe Outlook",
    subtitle: "ECB Policy Signals",
      image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400&h=250&fit=crop",
    
    link: "#"
  },
  {
    title: "Newsletter: Commodities Watch",
    subtitle: "Oil Climbs Again",
      image: "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=1200&h=600&fit=crop",
    link: "#"
  }
];



  const latestNews = [
    { 
      time: '19 min', 
      title: 'French Inflation Decelerates to Seven-Month Low on Energy',
      slug: 'french-inflation-decelerates-seven-month-low-energy',
      category: 'Economics'
    },
    { 
      time: '22 min', 
      title: 'China Vanke Fallout Seen as Smaller Builder Talks State Support',
      slug: 'china-vanke-fallout-smaller-builder-state-support',
      category: 'Markets'
    },
    { 
      time: '40 min', 
      title: 'Insurer Prudential Announces $1.2 Billion Share Buyback Program',
      slug: 'prudential-announces-billion-share-buyback',
      category: 'Markets'
    },
    { 
      time: '45 min', 
      title: 'Next Lifts Profit Forecast Again on Strong Holiday Season Sales',
      slug: 'next-lifts-profit-forecast-holiday-sales',
      category: 'Retail'
    },
    { 
      time: '50 min', 
      title: 'Mirae Asset India Veteran Mahendra Jajoo Joins Quant Mutual Fund',
      slug: 'mahendra-jajoo-joins-quant-mutual-fund',
      category: 'Finance'
    },
    { 
      time: '2 hr', 
      title: 'AB InBev Reacquires Stake in US Container Plants for $3 Billion',
      slug: 'ab-inbev-stake-container-plants',
      category: 'Business'
    },
    
    
    
    
    
    
    
    
    
  ];

  const inFocusTags = [
    'US Attacks on Venezuela',
    "Trump's Second Term",
    'UK Economy',
    'US Stocks',
    'NATO',
    'US 2026 Election',
  ];


  useEffect(() => {
  const interval = setInterval(() => {
    setActiveSlide(prev =>
      prev === newsletters.length - 1 ? 0 : prev + 1
    );
  }, 4000);

  return () => clearInterval(interval);
  }, [newsletters.length]);

 


  const MAIN_TABS = ['All Categories', 'Markets', 'Economics', 'Technology', 'Politics', 'Crypto'];
  const filteredNews = activeTab === 'All Categories'
    ? latestNews
    : latestNews.filter(n => n.category === activeTab);

  return (
    <aside className="latest-sidebar">

      {/* Sidebar Advertisement Banner */}
       <div className="sidebar-ad-banner">
        <div className="sidebar-ad-inner">
          <span className="sidebar-ad-label">Advertisement</span>
          <Link to={currentAd.link} className="sidebar-ad-link">
          <div className="sidebar-ad-content">
            
            {/* <div className="sidebar-ad-image">
              <img
                src="https://images.unsplash.com/photo-1486325212027-8081e485255e?w=350&h=200&fit=crop"
                
                alt="Advertisement"
              /> */}
             
             <div className="sidebar-ad-content">
            <div className="sidebar-ad-image">
              <img src={currentAd.image} alt="Ad" />
            </div>


            </div>
            <div className="sidebar-ad-body">
              <p className="sidebar-ad-tag">REDBOX GLOBAL ORIGINALS</p>
            
                <h4 className="sidebar-ad-title">{currentAd.title}</h4>
              <p className="sidebar-ad-sub">Exclusive insights starting April 2026</p>
              <p className="sidebar-ad-sub">{currentAd.subtitle}</p>
             
            </div>
            <div className="sidebar-ad-brand">
              <span className="sidebar-ad-brand-name">Redbox Global</span>
              <span className="sidebar-ad-brand-tag">INVEST SMARTER</span>
            </div>
          </div>
          </Link>
        </div>
      </div>

      <div className="latest-header">
        <h2>Latest</h2>
      </div>

      {/* Category tabs */}
      <div className="latest-tabs-row">
        {MAIN_TABS.map(tab => (
          <button
            key={tab}
            className={`latest-tab${activeTab === tab ? ' active' : ''}`}
            onClick={() => setActiveTab(prev => prev === tab ? 'All Categories' : tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      
      <ul className="latest-list">
        {filteredNews.map((item, index) => (
          <li className="latest-item" key={index}>
            <span className="latest-time">{item.time}</span>
            <h3><Link to={`/latest-news/${item.slug}`}>{item.title}</Link></h3>
          </li>
        ))}
      </ul>
      <Link to="/#latest" className="see-all-latest">See all latest →</Link>

      {/* In Focus Widget */}
      <div className="in-focus-widget">
        <h3>In Focus</h3>
        <div className="in-focus-tags">
          {inFocusTags.map((tag, index) => (
            <a href="#" className="in-focus-tag" key={index}>{tag}</a>
          ))}
        </div>
      </div>

      {/* Redbox  News Now Widget */}
      <div className="news-now-widget">

        {/* Tabs */}
  <div className="news-tabs">
    {["India", "USA", "China", "UK", "Russia", "Europe"].map((region) => (
      <button
        key={region}
        className={`news-tab ${activeRegion === region ? "active" : ""}`}
        onClick={() => setActiveRegion(region)}
      >
        {region}
      </button>
    ))}
  </div>
        <h3>{activeRegion} News Now</h3>
      {/* <h3>Redbox Global  News Now</h3> */}
        <p>Listen to the latest: Venezuela Regroups With New Leader, Maduro Pleads 'Not Guilty'</p>
        <div className="audio-player">
          <div className="play-btn">
            <svg viewBox="0 0 24 24"><polygon points="6,4 18,12 6,20" fill="white"/></svg>
          </div>
          <div className="audio-progress">
            <div className="audio-progress-bar"></div>
          </div>
          <span className="audio-time">6:50</span>
        </div>
        <p className="updated-time">Updated 42 min ago</p>
      </div>

      {/* Subscriber Widget */}
      <div className="subscriber-widget">
        <span className="subscriber-badge">SUBSCRIBER ONLY</span>
        <h4>Markets Daily India</h4>
        <p>Key news and movers in this fast-growing market and globally before the trading day starts.</p>
        <div className="subscribe-checkbox">
          <input type="checkbox" id="promo-check" />
          <label htmlFor="promo-check">Bloomberg may send me offers and promotions.</label>
        </div>
        <Link to="/subscribe">
          <button className="subscribe-button">🔒 Subscribe</button>
        </Link>
        <p className="subscribe-terms">
          By continuing, I agree to the <a href="#">Privacy Policy</a> and <a href="#">Terms of Service</a>.
        </p>
      </div>

      {/* Listen, Watch and Catch Up */}

        <div className="newsletter-slider">
        <h3>Listen, Watch and Catch Up</h3>

     <div className="slider-card">
       <img
        src={newsletters[activeSlide].image}
       alt="newsletter"
       className="slider-image"
       />

    <div className="slider-content">
      <p className="slider-label">{newsletters[activeSlide].title}</p>
      <h4>{newsletters[activeSlide].subtitle}</h4>
    </div>
  </div> 

  {/* Navigation */}
  {/* <div className="slider-controls"> */}
    <div className="dots">
      {newsletters.map((_, index) => (
        <span
          key={index}
          className={`dot ${activeSlide === index ? "active" : ""}`}
          onClick={() => setActiveSlide(index)}
        />
      ))}
    </div>

    <div className="arrows">
      <button
        onClick={() =>
          setActiveSlide(
            activeSlide === 0
              ? newsletters.length - 1
              : activeSlide - 1
          )
        }
      >
        ‹
      </button>

      <button
        onClick={() =>
          setActiveSlide(
            activeSlide === newsletters.length - 1
              ? 0
              : activeSlide + 1
          )
        }
      >
        ›
      </button>
    </div>
  </div>
{/* </div>  */}



      
    </aside>
  );
};

export default LatestSidebar;

